import { Spinner, Layout } from '@shopify/polaris'

export function LoadingSpinner() {
  return (
    <Layout>
      <Layout.Section>
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          height: '100vh' 
        }}>
          <Spinner accessibilityLabel="Loading" size="large" />
        </div>
      </Layout.Section>
    </Layout>
  )
}